import { DrEmeryOpener } from "@/shared/components/dashboard/DrEmeryOpener";
import { useLanguage } from "@/shared/i18n/LanguageContext";
import { useT } from "@/shared/i18n/useT";
import { useVertical } from "@/shared/contexts/VerticalContext";
import { registerWidget } from "@/shared/dashboard/widgets/registry";
import type { WidgetProps } from "@/shared/dashboard/widgets/types";

function SupervisorOpenerWidgetImpl(_: WidgetProps) {
  const { locale } = useLanguage();
  const t = useT();
  const { vertical, verticalConfig } = useVertical();
  const supervisorName = verticalConfig.supervisor?.identity.name;

  return (
    <DrEmeryOpener
      locale={locale as "en" | "uk" | "pl" | "ro"}
      supervisorName={supervisorName}
      vertical={vertical}
      variant="inline"
      fallback={t("ui.supervisorOpenerWidget.caseloadPrompt")}
    />
  );
}

registerWidget({
  id: "supervisorOpener",
  component: SupervisorOpenerWidgetImpl,
  supportedSlots: new Set(["hero"]),
  displayName: "Supervisor Opener",
});

export const SupervisorOpenerWidget = SupervisorOpenerWidgetImpl;
